import config from "../api/config";
import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

const NewPassword = () => {
  const location = useLocation();
  const navigate = useHistory();
  const token = location.state?.resetToken || location.data;
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token || !password || password !== confirmation) return;
    setBusy(true);
    setError("");
    try {
      await config.post("/api/auth/v1/newPassword", { password }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate.replace("/");
    } catch {
      setError("Не удалось изменить пароль. Проверьте требования к паролю или запросите новый код.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login_container" style={{ height: "100vh" }}>
      <div className="wrapper">
        <header>Новый пароль</header>
        {!token ? <p role="alert">Сначала подтвердите номер телефона. <Link to="/verify?mode=forgot">Получить код</Link></p> : <form onSubmit={handleSubmit}>
          <div className="field password"><div className="input-area">
            <input type="password" autoComplete="new-password" placeholder="Новый пароль"
              value={password} required minLength={4} maxLength={16}
              onChange={(event) => setPassword(event.target.value)} />
          </div></div>
          <div className="field password"><div className="input-area">
            <input type="password" autoComplete="new-password" placeholder="Повторите пароль"
              value={confirmation} required
              onChange={(event) => setConfirmation(event.target.value)} />
          </div></div>
          <p>4–16 символов: заглавная и строчная буква, цифра и специальный символ.</p>
          {error && <p role="alert" className="text-danger">{error}</p>}
          <input type="submit" value={busy ? "Подождите…" : "Сохранить"}
            disabled={busy || !password || password !== confirmation} />
        </form>}
      </div>
    </div>
  );
};

export default NewPassword;
